import React from 'react'
import PropTypes from 'prop-types'

import { getQueryString } from '../../utils/url'
import { AppLinkButton } from './styles/Button.style'

const Input = ({ to, ...rest }) => {
  return (
    <AppLinkButton to={`${to}${getQueryString()}`} {...rest} />
  )
}

Input.propTypes = {
  to: PropTypes.string.isRequired
}

export default Input
